import { render, staticRenderFns } from "./ResumenIT.vue?vue&type=template&id=626b8765&scoped=true"
import script from "./ResumenIT.vue?vue&type=script&lang=ts"
export * from "./ResumenIT.vue?vue&type=script&lang=ts"
import style0 from "./ResumenIT.vue?vue&type=style&index=0&id=626b8765&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "626b8765",
  null
  
)

export default component.exports